import { memo } from "react";

function ExcessiveLength(props) {
  const { color= "#666666", size = 12 } = props;
  return (
    <svg
      width={size+2}
      height={size}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0.667969V4.66797H12V0.667969H0ZM3.71667 3.66797H1V1.66797H3.71667V3.66797ZM7.26667 3.66797H4.71667V1.66797H7.26667V3.66797ZM11 3.66797H8.28333V1.66797H11V3.66797Z"
        fill={color}
      />
      <path
        d="M11.6667 7.43203L9.56671 9.53203L8.86671 8.83203L9.71657 7.93216H2.28337L3.13337 8.83216L2.43337 9.53216L0.333374 7.43216L2.43337 5.33216L3.13337 6.03216L2.28351 6.93203H9.71671L8.86671 6.03203L9.56671 5.33203L11.6667 7.43203Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(ExcessiveLength);
